var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _defs;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgGift = function SvgGift(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 192,
    height: 201,
    viewBox: "0 0 192 201",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M141.957 153.629L158.959 73.2668L33.6128 70.0036L39.8017 153.629L141.957 153.629Z",
    fill: "#C4C4C4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M141.957 153.629L158.959 73.2668L33.6128 70.0036L39.8017 153.629L141.957 153.629Z",
    fill: "url(#paint0_linear)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M141.957 154.139L159.807 71.845L140.705 70.8876L121.44 154.139L141.957 154.139Z",
    fill: "#7EC2E4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M59.7073 28.1558C64.6872 21.9177 80.7202 48.8927 88.1142 63.16C76.861 63.7562 55.5089 52.2752 46.2394 46.4602C46.2394 46.4602 45.8799 46.0339 45.8734 45.8158C45.6618 38.6911 54.2145 37.2422 55.1812 36.6931C56.1478 36.144 53.4824 35.9534 59.7073 28.1558Z",
    fill: "#CF425C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M163.903 72.739L166.029 63.0118L29.8601 61.4059L29.1575 71.9808L163.903 72.739Z",
    fill: "#C4C4C4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M163.903 72.739L166.029 63.0118L29.8601 61.4059L29.1575 71.9808L163.903 72.739Z",
    fill: "url(#paint1_linear)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M94.2684 153.585L98.225 61.5933L74.8794 61.5934L80.4054 153.585L94.2684 153.585Z",
    fill: "#CF425C"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M153.595 100.657L34.5858 96.5067L36.3395 113.384L150.156 115.115L153.595 100.657Z",
    fill: "#CF425C"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M119.398 27.4876C110.26 22.249 93.1082 49.6793 85.6746 64.0492C100.361 61.8664 130.385 56.846 132.996 54.2267C136.26 50.9525 131.908 43.3128 128.101 41.6757C124.293 40.0386 130.821 34.036 119.398 27.4876Z",
    fill: "#CF425C"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 59.9717,
    y1: 53.102,
    x2: 123.178,
    y2: 151.675,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.135417,
    stopColor: "#FDC73C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7EFE0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 9.17721,
    y1: 22.2849,
    x2: 164.46,
    y2: 110.679,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.135417,
    stopColor: "#FDC73C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7EFE0"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgGift, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/gift.2f190711.svg";
export { ForwardRef as ReactComponent };